module.exports = __webpack_public_path__ + "img/wallet_pc_02.2283d7d7.png";